import { render, staticRenderFns } from "./ReviewExerciseGenerate.vue?vue&type=template&id=ae872276"
import script from "./ReviewExerciseGenerate.vue?vue&type=script&lang=js"
export * from "./ReviewExerciseGenerate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports